"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { isEditing } from "@builder.io/sdk-react";

export default function PageDataLayerDispatcher(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (isEditing()) {
      return;
    }

    const event = new CustomEvent("pageDataLayerRendered", {
      bubbles: true,
      detail: {
        pathname,
        searchParams: searchParams.toString(),
        timestamp: new Date().toISOString(),
      },
    });

    requestAnimationFrame(() => {
      window.dispatchEvent(event);
    });
  }, [pathname, searchParams]);

  return null;
}
